var DesignFacade = require('../../facade/design/design');
var EditorFacade = require('../../facade/editor/editor');
var ProjectFacade = require('../../facade/project/project');
var FormatFactory = require('../../factory/formats');
var CompanyInstance = require('../../factory/company').instance;
var DesygnerApi = require('../../factory/desygner-api');

module.exports = function () {
  var alert;
  var oldWidth = parseInt(this.editor.canvas.contentW);
  var oldHeight = parseInt(this.editor.canvas.contentH);

  getResizeDimensions.call(this)
    .then(addCopies)
    .then(resizeCopies)
    .then(_.partial(EditorFacade.handle, 'page', 'save'))
    .then(function () {
      alert && alert.close();
      INKIVE.Modal.toggleLock(false);
    });

  function getResizeDimensions () {
    var deferred = $.Deferred();
    var customFormat = null;

    if (this.$el.find('input.custom').is(':checked')) {
      var unit = this.$el.find('select.unit').val();
      var width = parseFloat(this.$el.find('input.size.page-width').val());
      var height = parseFloat(this.$el.find('input.size.page-height').val());

      customFormat = {
        width: width,
        height: height,
        unit: unit
      };
    }

    var checkedFormats = this.$el.find('.default-formats [type=checkbox]:checked');
    var formats = _.map(checkedFormats, function (el) {
      return FormatFactory.getFormat($(el).val());
    });

    if (checkedFormats.length) {
      $.when.apply($, formats).then(function () {
        var dimensions = _.toArray(arguments);

        customFormat && dimensions.push(customFormat);
        deferred.resolve(dimensions);
      });
    } else if (customFormat) {
      deferred.resolve([customFormat]);
    }

    var menu = this.$el.find('.ui-dropdown-content');

    this.$el.find('.popular-formats [type=checkbox]:checked').each(function () {
      menu.hide();
      createPrintableFormat($(this).attr('value'));
    });

    return deferred.promise();
  }

  function addCopies (dimensions) {
    var pageDimensions = {};
    var deferred = $.Deferred();

    showMessage(0, dimensions.length);
    EditorFacade.handle('page', 'save').then(_addCopies);
    return deferred.promise();

    function _addCopies () {
      var isLastPage = dimensions.length === 0;

      isLastPage && deferred.resolve(pageDimensions);
      isLastPage || ProjectFacade.handle('design', 'copy', {
        'design_id': INKIVE.Tool._current_design_id,
        'append': true,
        'stay': true,
        'save': false,
        'quiet': true
      }).then(function (data) {
        pageDimensions[data['page_number']] = dimensions.pop();
        _addCopies();
      });
    }
  }

  function resizeCopies (pageDimensions) {
    var deferred = $.Deferred();
    var resizeCalls = _.map(pageDimensions, function (dimension, pageNumber) {
      return _.partial(resizeCopy, dimension, pageNumber);
    });

    iterateResize();

    return deferred.promise();

    function iterateResize () {
      var isLastPage = resizeCalls.length === 0;

      isLastPage && deferred.resolve();
      isLastPage || resizeCalls.shift()().then(iterateResize);
    }

    function resizeCopy (dim, pageNumber) {
      var deferred = $.Deferred();
      showMessage(_.size(pageDimensions) - resizeCalls.length - 1, _.size(pageDimensions));

      EditorFacade.handle('page', 'move_to', {
        'page_number': pageNumber
      }).then(function () {
        DesignFacade.once('template.update', deferred.resolve);
        _.delay(function () {
          DesignFacade.set('template', {
            size: dim
          });
        }, 500);
      });

      return deferred.promise();
    }
  }

  function showMessage (index, total) {
    function show () {
      INKIVE.Modal.toggleLock(false);

      var message = [
        '<b style="font-weight: 400">',
        INKIVE.TranslateHelper.translate('modal.alert.resize_page', {
          page: index + 1,
          from: total,
          percent: parseInt(index * 100 / total)
        }),
        '</b>'
      ];

      alert = INKIVE.Modal.alertMessage(message.join(''), {
        skip: false,
        loader: true
      });

      INKIVE.Modal.toggleLock(true);
    }

    alert && alert.close(show);
    alert || show();
  }

  function createPrintableFormat (formatId) {
    INKIVE.Modal.togglePageLoader(true);

    CompanyInstance.getProjectData().then((projectData) => {
      DesygnerApi.post('brand/companies/' + projectData.company.id + '/designs', {
        based_on: projectData.id,
        format: parseInt(formatId),
        pages: [INKIVE.Tool._current_design_id]
      }).then((newProjectData) => {
        INKIVE.Modal.togglePageLoader(false);
        newProjectData['encoded_id'] && window.open(INKIVE.C.CTRL + '?id=' + newProjectData['encoded_id'] + '&print');
      });
    });
  }
};
